// extracted by css-extract-rspack-plugin
export default {"wrapper":"SubscriptionSettingsPage-module__wrapper--eBPde"};